import React from 'react';
import { DeviceLocation, Load, OrganizationLocation, Tractor, Trailer } from '../../../types';
import { getNextStop } from './get-next-stop';
import { useOrganizationQuery } from '../../../api/queries/use-organization-query';
import { OrgQueryKeys } from '../../../api/config';
import { getCurrentLoadWeight } from '../../../utils/weight-utils';
import { useCompanyId } from '../../../app/agistics-context';
import axios from 'axios';

export const useRouteData = (deviceLocation: DeviceLocation, load?: Load | undefined): any => {
    const [route, setRoute] = React.useState(null);
    const companyId = useCompanyId();
    const { data: organizationLocations } = useOrganizationQuery<OrganizationLocation[]>(OrgQueryKeys.locations, { disableOnFreemium: true });
    const { data: tractors = [] } = useOrganizationQuery<Tractor[]>(OrgQueryKeys.tractors);
    const { data: trailers = [] } = useOrganizationQuery<Trailer[]>(OrgQueryKeys.trailers);

    const tractorWeight = tractors.find(x => x.id === load?.tractorId)?.weight;
    const trailerWeight = trailers.find(x => x.id === load?.trailerId)?.weight;

    const stops = load ? load.stops : null

    // we probably need to generate the destination coords off the 'center' of geofence if exists.
    // need to include avoidance zones, as it can really thorw off estimated time of arrival.
    React.useEffect(() => {
        let stopLatLongs: Record<number, { lat: number, long: number }> | null = null;
        if (organizationLocations && stops) {
            stopLatLongs = stops.reduce((acc, stop) => {
                const orgLoc = organizationLocations.find(x => x.id === stop.organizationLocationId);
                if (!orgLoc) {
                    return acc;
                }
                const geoFence = orgLoc.customGeofence || orgLoc?.location?.geoLocation
                if (!geoFence) {
                    return acc
                }
                const { latitude, longitude } = geoFence

                return { ...acc, [stop.id]: { lat: latitude, long: longitude } };
            }, {});
        }

        if (stopLatLongs && deviceLocation?.latitude) {
            const nextStop = getNextStop(stops);
            if (nextStop) {
                const nextStopWaypoint = {
                    latitude: stopLatLongs[nextStop.id]?.lat,
                    longitude: stopLatLongs[nextStop.id]?.long
                };
                const driverWaypoint = {
                    latitude: deviceLocation.latitude,
                    longitude: deviceLocation.longitude
                };

                let currentWeight;
                if (load) {
                    currentWeight = getCurrentLoadWeight(tractorWeight, trailerWeight, load.stops);
                }

                //pass the calculated current load weight as the equipment weight, since we only care about
                //the next stop, not future stops or past stops
                const postPayload = {
                    stops: [driverWaypoint, nextStopWaypoint],
                    ...(currentWeight ? {equipmentWeight: currentWeight} : {})
                }
                axios.post(`${API_BASE}/api/organizations/${companyId}/routing`, postPayload).then((response) => {
                    if (response.data) {
                        const route = response.data?.routes?.[0];
                        if (route) {
                            setRoute(route);
                        }
                    }
                });
            }
        }
    }, [deviceLocation]);

    return route;
};
